module.exports = __webpack_public_path__ + "static/media/BadgeTT.de675327.svg";